import { render, staticRenderFns } from "./InterfaceAge.vue?vue&type=template&id=1622d032"
import script from "./InterfaceAge.vue?vue&type=script&lang=js"
export * from "./InterfaceAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports